module.exports = __webpack_public_path__ + "static/private-cloudfront-config-4-996ca71e85ef80fc1f37f4c0986722d7.png";